import numeral from './numeral';
import { COUNTRIES } from '@constants';

export default function format(amount) {
    if (typeof amount === 'undefined' || amount === '') return amount;
    const number = parseFloat(amount.replace(/[^0-9]/g, ''));
    if (window.country === COUNTRIES.CL || window.country === COUNTRIES.CO) {
        return numeral(number).format('0,00');
    }
    return numeral(number / 100).format('0,0.00');
}